import environments from "./environments";

export const envConfig = environments.find(
    env => env.url === window.location.host
);

window.environments = environments;
window.currentEnvironment = envConfig;
